"use client";
import {
	faBaby,
	faBolt,
	faBone,
	faBook,
	faBookAtlas,
	faBookOpen,
	faBrain,
	faChessKnight,
	faClock,
	faCommentDots,
	faComments,
	faDice,
	faDiceD20,
	faDragon,
	faFire,
	faFistRaised,
	faGlobe,
	faGrinTongueSquint,
	faHandHoldingHeart,
	faHandshakeSlash,
	faHatWizard,
	faHeart,
	faHeartCrack,
	faInfinity,
	faJar,
	faLaughSquint,
	faLightbulb,
	faMagnifyingGlass,
	faMask,
	faPaw,
	faPersonRunning,
	faShieldHalved,
	faSkull,
	faTheaterMasks,
	faUserAstronaut,
	faWrench,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import { useState } from "react";

const SystemsPage = () => {
	const systems = [
		{
			title: "Dragones & Mazmorras",
			subtitle: "El juego de rol más famoso",
			bullets: [
				{
					text: "Juega en Madrid a la edición más famosa del juego de rol más popular del mundo",
					icon: faDragon,
					animClass: "dnd-1",
				},
				{
					text: "Reglas accesibles que facilitan una experiencia épica para cualquier grupo",
					icon: faBook,
					animClass: "dnd-2",
				},
				{
					text: "Aventuras personalizadas para sesiones únicas y memorables",
					icon: faBookAtlas,
					animClass: "dnd-3",
				},
				{
					text: "Ideal para iniciarse o profundizar en campañas con combate, magia y exploración",
					icon: faChessKnight,
					animClass: "dnd-4",
				},
			],
			image: "/images/sistemas/dragones.webp",
			buttonText: "Jugar D&D en Madrid",
			whatsappMessage:
				"¡Hola! Estoy interesado/a en una partida de Dragones y Mazmorras en Madrid. ¿Podrías darme más información?",
		},
		{
			title: "Láseres y Sentimientos",
			subtitle: "Sin complicaciones",
			bullets: [
				{
					text: "Crea tu personaje en minutos y empieza tu aventura galáctica",
					icon: faUserAstronaut,
					animClass: "laser-1",
				},
				{
					text: "Narración improvisada: tu grupo construye la historia en tiempo real",
					icon: faCommentDots,
					animClass: "laser-2",
				},
				{
					text: "Un juego ideal para partidas rápidas y experiencias de rol ligeras",
					icon: faBrain,
					animClass: "laser-3",
				},
				{
					text: "Perfecto para iniciarse en el rol en casa, en grupo o en nuestro local",
					icon: faDice,
					animClass: "laser-4",
				},
			],
			image: "/images/sistemas/lasers.webp",
			buttonText: "Probar Láseres y Sentimientos",
			whatsappMessage:
				"Hola, me gustaría reservar una partida de Láseres y Sentimientos. ¿Qué disponibilidad tenéis?",
		},
		{
			title: "DRAGON",
			subtitle: "Infinitos mundos a descubrir",
			bullets: [
				{
					text: "Crea personajes únicos para historias épicas y originales",
					icon: faInfinity,
					animClass: "tarragon-1",
				},
				{
					text: "Una forma ágil y emocionante de jugar al rol en Madrid",
					icon: faPersonRunning,
					animClass: "tarragon-2",
				},
				{
					text: "Enfocado en la narrativa compartida: todos construyen el mundo",
					icon: faComments,
					animClass: "tarragon-3",
				},
				{
					text: "Inspirado en Agon, diseñado para sesiones inolvidables entre amigos",
					icon: faShieldHalved,
					animClass: "tarragon-4",
				},
			],
			image: "/images/sistemas/tarragon.webp",
			buttonText: "Explorar DRAGON",
			whatsappMessage: "Buenas, estoy buscando una partida de DRAGON en Madrid. ¿Podríais ayudarme?",
		},
		{
			title: "Eat the Reich",
			subtitle: "Su sangre es tu arma. Hitler, tu presa",
			bullets: [
				{
					text: "Encarnas un comando de vampiros en una aventura pulp en plena segunda guerra mundial",
					icon: faSkull,
					animClass: "reich-1",
				},
				{
					text: "Combate sobrenatural con mecánicas de sangre y poder vampírico",
					icon: faFire,
					animClass: "reich-2",
				},
				{
					text: "Estética de cómic, narrativa adulta y ritmo cinematográfico",
					icon: faBookOpen,
					animClass: "reich-3",
				},
				{
					text: "Ideal para grupos que buscan una experiencia intensa y catártica",
					icon: faFistRaised,
					animClass: "reich-4",
				},
			],
			image: "/images/sistemas/eatthereich.webp",
			buttonText: "Reservar Eat the Reich",
			whatsappMessage:
				"¡Hola! Quiero una partida de Eat the Reich. ¿Tenéis disponibilidad este fin de semana?",
		},
		{
			title: "El Atraco Meloso",
			subtitle: "Osos atracadores, y un gran botín de miel",
			bullets: [
				{
					text: "Organiza el atraco más divertido que puedas imaginar con tu grupo",
					icon: faJar,
					animClass: "meloso-1",
				},
				{
					text: "Crea tu banda de osos: conductor, hacker o forzudo, ¡tú eliges!",
					icon: faPaw,
					animClass: "meloso-2",
				},
				{
					text: "Un juego perfecto para romper el hielo y reír a carcajadas",
					icon: faHandshakeSlash,
					animClass: "meloso-3",
				},
				{
					text: "Sesiones cortas ideales para fiestas, cumpleaños o eventos en casa",
					icon: faLaughSquint,
					animClass: "meloso-4",
				},
			],
			image: "/images/sistemas/meloso.webp",
			buttonText: "Atracar con osos",
			whatsappMessage: "Hola, me encantaría jugar al Atraco Meloso con mi grupo. ¿Podríamos reservar?",
		},
		{
			title: "Masks",
			subtitle: "Superhéroes adolescentes entre poderes y emociones",
			bullets: [
				{
					text: "Vive aventuras llenas de acción con héroes que apenas están aprendiendo a controlar sus poderes",
					icon: faBolt,
					animClass: "masks-1",
				},
				{
					text: "Un juego narrativo donde las relaciones, la identidad y las decisiones pesan más que las reglas",
					icon: faComments,
					animClass: "masks-2",
				},
				{
					text: "Explora el drama adolescente: amistades, rivalidades y romances… todo mientras salvas el mundo",
					icon: faHeart,
					animClass: "masks-3",
				},
				{
					text: "Perfecto para quienes buscan tanto acción superheroica como historias profundas y emocionales",
					icon: faTheaterMasks,
					animClass: "masks-4",
				},
			],
			image: "/images/sistemas/masks.webp",
			buttonText: "Reservar partida heroica",
			whatsappMessage:
				"¡Hola! Quiero jugar a Masks, el juego narrativo de superhéroes adolescentes. ¿Cuándo tenéis sesiones disponibles?",
		},

		{
			title: "Detectives de Monstruos",
			subtitle: "Misterio, intriga y acción para los más pequeños",
			bullets: [
				{
					text: "Juego de rol infantil adaptado para niños desde los 3 años",
					icon: faBaby,
					animClass: "monstruos-1",
				},
				{
					text: "Aventura educativa con investigación, imaginación y muchos monstruos simpáticos",
					icon: faMagnifyingGlass,
					animClass: "monstruos-2",
				},
				{
					text: "Dos horas de entretenimiento seguro y guiado por un máster profesional",
					icon: faClock,
					animClass: "monstruos-3",
				},
				{
					text: "Una forma divertida de introducir el rol en cumpleaños y eventos familiares",
					icon: faHandHoldingHeart,
					animClass: "monstruos-4",
				},
			],
			image: "/images/sistemas/pequenos.webp",
			buttonText: "Rol para niños",
			whatsappMessage:
				"Buenas, busco una partida de Detectives de Monstruos para mi hijo/a. ¿Tenéis disponibilidad?",
		},
		{
			title: "Cabezahuecas",
			subtitle: "Sé un esqueleto, finge ser humano",
			bullets: [
				{
					text: "Encarnas un esqueleto en una misión absurda en el mundo humano",
					icon: faBone,
					animClass: "cabezas-1",
				},
				{
					text: "Juega al rol con humor y situaciones surrealistas para todos los públicos",
					icon: faMask,
					animClass: "cabezas-2",
				},
				{
					text: "Una partida ideal para sesiones sueltas o eventos temáticos en casa",
					icon: faHatWizard,
					animClass: "cabezas-3",
				},
				{
					text: "Ideal para grupos que buscan risas, creatividad y diversión sin reglas complicadas",
					icon: faGrinTongueSquint,
					animClass: "cabezas-4",
				},
			],
			image: "/images/sistemas/cabezahuecas.webp",
			buttonText: "Jugar Cabezahuecas",
			whatsappMessage: "¡Hola! Quiero reservar una partida de Cabezahuecas. ¿Cuándo podríamos jugar?",
		},
		{
			title: "Pasión de las Pasiones",
			subtitle: "Drama, romance y traiciones al estilo telenovela",
			bullets: [
				{
					text: "Vive intensas historias de amor y traición en un juego de rol único",
					icon: faHeartCrack,
					animClass: "pasiones-1",
				},
				{
					text: "Crea personajes dramáticos con secretos oscuros y pasiones prohibidas",
					icon: faMask,
					animClass: "pasiones-2",
				},
				{
					text: "Sistema ligero que prioriza el drama sobre las reglas complicadas",
					icon: faTheaterMasks,
					animClass: "pasiones-3",
				},
				{
					text: "Perfecto para grupos que buscan risas, emociones fuerte y momentos memorables",
					icon: faLaughSquint,
					animClass: "pasiones-4",
				},
			],
			image: "/images/sistemas/pasion.webp",
			buttonText: "Reservar partida dramática",
			whatsappMessage:
				"¡Hola! Quiero vivir una historia de Pasión de las Pasiones. ¿Tenéis sesiones disponibles?",
		},
		{
			title: "Cualquier otro sistema",
			subtitle: "Tú traes la idea, nosotros ponemos las reglas",
			bullets: [
				{
					text: "¿Tienes un sistema en mente? Lo adaptamos para jugarlo en Madrid o donde quieras",
					icon: faDiceD20,
					animClass: "otro-1",
				},
				{
					text: "Asesoramiento personalizado para encontrar el mejor sistema para tu historia",
					icon: faLightbulb,
					animClass: "otro-2",
				},
				{
					text: "Convertimos tus ideas en una experiencia de rol a medida, en casa o en nuestro local",
					icon: faWrench,
					animClass: "otro-3",
				},
				{
					text: "Desde clásicos hasta indies: hacemos realidad cualquier tipo de aventura",
					icon: faGlobe,
					animClass: "otro-4",
				},
			],
			image: "/images/sistemas/tupropio.webp",
			buttonText: "Personalizar partida",
			whatsappMessage:
				"Hola, tengo un sistema de rol específico que me gustaría jugar. ¿Podríais ayudarme a organizarlo?",
		},
	];

	// Add this at the top of your file (you can change the value as needed)
	const HOVER_COLOR = "#f93d3d"; // Tailwind's red-500

	const iconAnimations = {
		// Dragones & Mazmorras
		"dnd-1": {
			initial: { rotate: 0, scale: 1 },
			hover: {
				rotate: [0, 15, -15, 0],
				scale: [1, 1.2, 1],
				color: HOVER_COLOR,
				transition: { duration: 0.8 },
			},
		},
		"dnd-2": {
			initial: { y: 0 },
			hover: {
				y: -5,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"dnd-3": {
			initial: { rotateY: 0 },
			hover: {
				rotateY: 180,
				color: HOVER_COLOR,
				transition: { duration: 0.6 },
			},
		},
		"dnd-4": {
			initial: { x: 0, y: 0 },
			hover: {
				x: 5,
				y: -3,
				color: HOVER_COLOR,
				transition: { duration: 0.4 },
			},
		},

		// Láseres y Sentimientos
		"laser-1": {
			initial: { y: 0 },
			hover: {
				y: -8,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"laser-2": {
			initial: { scale: 1 },
			hover: {
				scale: 1.2,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"laser-3": {
			initial: { rotate: 0 },
			hover: {
				rotate: 360,
				color: HOVER_COLOR,
				transition: { duration: 0.8, ease: "linear" },
			},
		},
		"laser-4": {
			initial: { rotateZ: 0 },
			hover: {
				rotateZ: 15,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},

		// Tarragon
		"tarragon-1": {
			initial: { scale: 1 },
			hover: {
				scale: 1.3,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"tarragon-2": {
			initial: { y: 0 },
			hover: {
				y: -6,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"tarragon-3": {
			initial: { rotate: 0 },
			hover: {
				rotate: 15,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"tarragon-4": {
			initial: { x: 0 },
			hover: {
				x: 5,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},

		// Eat the Reich (already had color in reich-2)
		"reich-1": {
			initial: { rotate: 0 },
			hover: {
				rotate: 15,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"reich-2": {
			initial: { scale: 1 },
			hover: {
				scale: 1.3,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"reich-3": {
			initial: { rotateY: 0 },
			hover: {
				rotateY: 180,
				color: HOVER_COLOR,
				transition: { duration: 0.6 },
			},
		},
		"reich-4": {
			initial: { y: 0 },
			hover: {
				y: -5,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},

		// El Atraco Meloso
		"meloso-1": {
			initial: { y: 0 },
			hover: {
				y: -5,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"meloso-2": {
			initial: { rotate: 0 },
			hover: {
				rotate: 15,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"meloso-3": {
			initial: { scale: 1 },
			hover: {
				scale: 1.2,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"meloso-4": {
			initial: { x: 0 },
			hover: {
				x: 5,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},

		// Detectives de Monstruos
		"monstruos-1": {
			initial: { y: 0 },
			hover: {
				y: -6,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"monstruos-2": {
			initial: { scale: 1 },
			hover: {
				scale: 1.2,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"monstruos-3": {
			initial: { rotate: 0 },
			hover: {
				rotate: 15,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"monstruos-4": {
			initial: { x: 0, y: 0 },
			hover: {
				x: 5,
				y: -3,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},

		// Cabezahuecas
		"cabezas-1": {
			initial: { rotate: 0 },
			hover: {
				rotate: 20,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"cabezas-2": {
			initial: { y: 0 },
			hover: {
				y: -5,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"cabezas-3": {
			initial: { scale: 1 },
			hover: {
				scale: 1.2,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"cabezas-4": {
			initial: { x: 0 },
			hover: {
				x: 5,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},

		// Masks - Superhéroes adolescentes
		"masks-1": {
			initial: { y: 0 },
			hover: {
				y: -8,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"masks-2": {
			initial: { scale: 1 },
			hover: {
				scale: 1.25,
				rotate: -5,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"masks-3": {
			initial: { rotate: 0 },
			hover: {
				rotate: 12,
				scale: 1.15,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"masks-4": {
			initial: { x: 0, y: 0 },
			hover: {
				x: -6,
				y: -4,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},

		// Cualquier otro sistema
		"otro-1": {
			initial: { rotate: 0 },
			hover: {
				rotate: 360,
				color: HOVER_COLOR,
				transition: { duration: 0.8, ease: "linear" },
			},
		},
		"otro-2": {
			initial: { scale: 1 },
			hover: {
				scale: 1.3,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"otro-3": {
			initial: { rotateZ: 0 },
			hover: {
				rotateZ: 15,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		},
		"otro-4": {
			initial: { y: 0 },
			hover: {
				y: -5,
				color: HOVER_COLOR,
				transition: { duration: 0.3 },
			},
		}, // Pasión de las Pasiones
		"pasiones-1": {
			initial: { rotate: 0 },
			hover: {
				rotate: [0, 10, -10, 0],
				color: "#ff0000", // Dramatic red
				transition: {
					duration: 0.7,
					repeat: 1,
					repeatType: "reverse" as const,
				},
			},
		},
		"pasiones-2": {
			initial: { scale: 1 },
			hover: {
				scale: [1, 1.3, 1],
				color: "#d40078", // Passionate pink
				transition: {
					duration: 0.5,
					ease: "backOut",
				},
			},
		},
		"pasiones-3": {
			initial: { x: 0 },
			hover: {
				x: [0, 10, -10, 0],
				color: "#ff6b00", // Fiery orange
				transition: {
					duration: 0.6,
					repeat: Infinity,
					repeatType: "mirror" as const,
				},
			},
		},
		"pasiones-4": {
			initial: { opacity: 1 },
			hover: {
				opacity: [1, 0.3, 1],
				color: "#aa00ff", // Royal purple
				transition: {
					duration: 0.9,
					repeat: 1,
				},
			},
		},
	};

	const [hoveredIcon, setHoveredIcon] = useState<string | null>(null);

	return (
		<main className="bg-black text-white">
			{/* Hero Section with the specified header image */}
			<section
				className="relative py-32 bg-cover bg-center"
				style={{ backgroundImage: "url('/images/sistemas/sistemas_encabezado.webp')" }}
			>
				<div className="absolute inset-0 bg-black/60"></div>
				<div className="container mx-auto px-4 max-w-6xl relative z-10">
					<motion.h1
						className="font-amarante text-5xl md:text-7xl mb-6 text-center text-white"
						initial={{ opacity: 0, y: -20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.8 }}
					>
						<span className="headerFont inline-block pb-2 border-b-2 border-red-700">
							Sistemas de rol para todos los estilos de juego
						</span>
					</motion.h1>

					<motion.p
						className="text-xl text-gray-300 max-w-3xl mx-auto text-center mb-12"
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						transition={{ delay: 0.3, duration: 0.6 }}
					>
						En Madrid, nuestros Directores de Juego profesionales pueden dirigir cualquier sistema de rol que
						imagines. Sin embargo, estos son algunos de los sistemas de juego que más triunfan en nuestras
						partidas: Dragones y Mazmorras, Eat the Reich, El Atraco Meloso... ¡Explora nuestras opciones y
						contáctanos para una experiencia de rol a tu medida!
					</motion.p>
				</div>
			</section>

			{/* Systems Grid */}
			<section className="py-16 bg-black">
				<div className="container mx-auto px-4 max-w-7xl">
					<motion.div
						className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12"
						initial="hidden"
						animate="show"
						variants={{
							hidden: { opacity: 0 },
							show: {
								opacity: 1,
								transition: {
									staggerChildren: 0.1,
								},
							},
						}}
					>
						{systems.map((system, index) => (
							<motion.div
								key={index}
								className="bg-gray-900 rounded-lg overflow-hidden border-2 border-gray-800 hover:border-red-600 transition-colors duration-300 flex flex-col"
								variants={{
									hidden: { opacity: 0, y: 20 },
									show: { opacity: 1, y: 0 },
								}}
								whileHover={{ y: -5 }}
							>
								{/* Large System Image */}
								<div className="h-48 w-full overflow-hidden">
									<motion.img
										src={system.image}
										alt={system.title}
										className="w-full h-full object-cover"
										whileHover={{ scale: 1.05 }}
										transition={{ duration: 0.3 }}
									/>
								</div>

								<div className="p-6 flex-grow">
									{" "}
									{/* Added flex-grow here */}
									<div className="mb-4">
										<h2 className="font-amarante text-3xl text-white">{system.title}</h2>
										<p className="text-red-400">{system.subtitle}</p>
									</div>
									<ul className="space-y-4 mt-6">
										{system.bullets.map((bullet, i) => (
											<motion.li
												key={i}
												className="flex items-start cursor-pointer"
												onMouseEnter={() => setHoveredIcon(bullet.animClass)}
												onMouseLeave={() => setHoveredIcon(null)}
											>
												<motion.div
													className="mr-3 mt-1 text-red-400"
													variants={iconAnimations[bullet.animClass as keyof typeof iconAnimations]}
													initial="initial"
													animate={hoveredIcon === bullet.animClass ? "hover" : "initial"}
												>
													<FontAwesomeIcon icon={bullet.icon} size="lg" />
												</motion.div>
												<motion.p className="text-gray-300 hover:text-white transition-colors">
													{bullet.text}
												</motion.p>
											</motion.li>
										))}
									</ul>
								</div>

								<div className="px-6 py-4 bg-gray-700/50 border-t border-gray-600 flex justify-center">
									<motion.a
										href={`https://api.whatsapp.com/send?phone=34642367972&text=${encodeURIComponent(system.whatsappMessage)}`}
										className="p-4 text-white rounded font-amarante text-xl text-center transition-colors"
										target="_blank"
										rel="noopener noreferrer"
										whileHover={{
											scale: 1.1,
											boxShadow: "0 0 15px #f93d3d",
											backgroundColor: "white",
											color: "black",
											fontWeight: "900",
											fontStyle: "italic",
										}}
										whileTap={{ scale: 0.98 }}
									>
										{system.buttonText}
									</motion.a>
								</div>
							</motion.div>
						))}
					</motion.div>
				</div>
			</section>

			{/* CTA Section */}
			<section className="py-20 bg-gradient-to-b from-black to-red-900/20">
				<div className="container mx-auto px-4 max-w-4xl flex flex-col items-center text-center">
					<motion.h2
						className="font-amarante text-3xl md:text-4xl mb-6 text-white"
						initial={{ opacity: 0 }}
						whileInView={{ opacity: 1 }}
						viewport={{ once: true }}
					>
						¿No encuentras tu sistema favorito?
					</motion.h2>

					<motion.p
						className="text-xl text-gray-300 mb-8"
						initial={{ opacity: 0 }}
						whileInView={{ opacity: 1 }}
						transition={{ delay: 0.3 }}
						viewport={{ once: true }}
					>
						Trabajamos con cualquier sistema de rol. Cuéntanos qué quieres jugar y nos adaptamos a tus
						preferencias.
					</motion.p>

					<motion.a
						className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg font-amarante text-xl transition-colors"
						whileHover={{
							scale: 1.1,
							boxShadow: "0 0 15px #f93d3d",
							backgroundColor: "white",
							color: "black",
							fontWeight: "900",
							fontStyle: "italic",
						}}
						href={`https://api.whatsapp.com/send?phone=34642367972&text=${encodeURIComponent("Hola, tengo un sistema de rol específico que me gustaría jugar. ¿Podríais ayudarme a organizarlo?")}`}
						whileTap={{ scale: 0.98 }}
						initial={{ opacity: 0, y: 20 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
					>
						Consultar disponibilidad
					</motion.a>
				</div>
			</section>
		</main>
	);
};

export default SystemsPage;
